export default __webpack_public_path__ + "b800c0a402dc6ef4a09a8a2cabf21b0c.png";